import { useTranslation } from 'react-i18next'

const LOOM_EMBED_URL = 'https://www.loom.com/embed/34d895819672429a989272d995fbd248'

export function LiveDemoLoop() {
  const { t } = useTranslation()

  return (
    <section id="live-demo" className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-12">
      <div className="rounded-lg overflow-hidden bg-black marker-dot-card">
        {/* aspect-[89/54] is the recorded Loom walkthrough's ratio (54/89 ≈ 60.674%). */}
        <div className="aspect-[89/54]">
          <iframe
            src={LOOM_EMBED_URL}
            title={t('alt.liveDemo')}
            loading="lazy"
            frameBorder="0"
            allow="fullscreen"
            allowFullScreen
            className="w-full h-full block"
          />
        </div>
      </div>
    </section>
  )
}
